import styled from "styled-components";
import { BsPlusCircleFill, BsPlusCircle, BsCircleFill } from "react-icons/bs";

export const NotasDescription = styled.div`
  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: 83% 15%;
    gap: 2%;
    font-size: 0.875rem;
  }
`;

export const CrearNota = styled(BsPlusCircleFill)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const CrearNotaHover = styled(BsPlusCircle)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 56.9% auto 43%;
  z-index: 0;
  background-color: ${(props) => props.bg};

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const PersonInfo = styled.div`
  display: grid;
  grid-template-columns: 20% 75%;
  grid-gap: 5%;
`;

export const List = styled.ul`
  list-style: none;
`;

export const Bullet = styled(BsCircleFill)`
  position: absolute;
  left: -18px;
  font-size: 0.3rem;
  z-index: 1;
  align-self: center;
  color: #3c6ebe;
`;

export const NormalInputsFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: 20% 78%;
    grid-gap: 2%;
  }
`;

export const NormalInput = styled.input`
  border: 1px solid white;
  height: 38px;
  padding: 0px 10px;
  color: ${(props) => props.color && props.color};
  border-radius: 7px;

  &:focus {
    border-color: #dce6e6;
    outline: none;
  }

  &:hover {
    border-color: #dce6e6;
  }
`;

export const ModalButtons = styled.button`
  border-radius: 6px;
  border: 1px solid;
  border-color: ${(props) => (props.bg ? props.bg : "#787878")};
  height: 45px;
  width: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bg && props.bg};
  color: ${(props) => (props.bg ? "white" : "#787878")};
  outline: none;
`;
